import { AfterViewChecked, ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { Router, RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-screen-logged-out",
  templateUrl: "./logged-out.component.html",
  styleUrls: ["./logged-out.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, RouterLink, TranslatePipe],
})
export class LoggedOutComponent implements AfterViewChecked {
  readonly auth = inject(AuthService);
  router = inject(Router);
  
  ngAfterViewChecked() {
    if (this.auth.session.value) {
      this.router.navigate(["/content"]);
    }
  }
}
